import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './BankingInfoCardView';

export default withErrorWrapper(view);
